import React from 'react';
import { CalculatorIcon, CreditCardIcon, DumbbellIcon, HardHatIcon, HomeIcon, LandmarkIcon, ScaleIcon, ShieldCheckIcon, SmileIcon, SparklesIcon, TreesIcon, TruckIcon, WrenchIcon } from 'lucide-react';
import type { IndustryIconName } from '../../data/industries';
const icons = {
  truck: TruckIcon,
  sparkles: SparklesIcon,
  smile: SmileIcon,
  dumbbell: DumbbellIcon,
  calculator: CalculatorIcon,
  landmark: LandmarkIcon,
  home: HomeIcon,
  creditCard: CreditCardIcon,
  shield: ShieldCheckIcon,
  scale: ScaleIcon,
  trees: TreesIcon,
  wrench: WrenchIcon,
  hardHat: HardHatIcon
};
type IndustryIconProps = {
  name: IndustryIconName;
  className?: string;
};
export function IndustryIcon({
  name,
  className
}: IndustryIconProps) {
  const Icon = icons[name];
  return <Icon className={className} aria-hidden="true" data-id="element-564" data-mp="16okd8fq8op86" />;
}